(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('send-lab-compendium', {
            parent: 'entity',
            url: '/send-lab-compendium',
            data: {
                authorities: [],
                pageTitle: 'SendLabCompendiums'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/send-lab-compendium/list/send-lab-compendium.html',
                    controller: 'SendLabCompendiumController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
            }]
        })
    }
})();
